import request from '@/utils/request'
import host from '@/api/base/host'

// 课程分享
const express = host.path('loca:ljs', { module: 'express', dev: 'v1' })

export const updateExpressAddress = data => {
  return request({
    url: express('express/updateAddress'),
    method: 'post',
    data
  })
}
export const expressInfo2 = data => {
  return request({
    url: express('express/query/orderSn'),
    method: 'post',
    data
  })
}
export default {
  updateExpressAddress,
  // 物流列表
  expressList(data) {
    return request({
      url: express('express/list'),
      method: 'post',
      data
    })
  },
  // 物流详情
  expressInfo(data) {
    return request({
      url: express('express/query/express100'),
      method: 'post',
      data
    })
  },
  expressInfo2
}
